module.exports = __webpack_public_path__ + "img/D201703_4.5381b8fe.jpg";